import { Button, Dropdown } from '@ibsys/kit';
import { ImageOffIcon, MoreHorizontalIcon } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { BrokenContentImage } from '../model/htmlContent';
import { getBrokenImageMenuItems } from './brokenImageMenuItems';

type Props = {
  /** Мелкие не загрузившиеся картинки облака */
  images: BrokenContentImage[];
};

/** Мелкие не загрузившиеся картинки — бледной кнопкой «···» в конце облака; пункт открывает картинку в новой вкладке. */
export const BrokenImagesDropdown: FC<Props> = ({ images }) => {
  const { t } = useTranslation(['dialogs']);

  const options = getBrokenImageMenuItems(images, ImageOffIcon);

  return (
    <Dropdown options={options}>
      <Button
        variant="ghost"
        size="icon"
        className="h-5 w-7 self-start text-muted-foreground/60 not-italic hover:text-muted-foreground"
        aria-label={t('dialogs:textFeed.brokenImages')}
        icon={<MoreHorizontalIcon className="size-3.5" />}
      />
    </Dropdown>
  );
};
